import React, { useState, useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setSamithi_MembersList, setSamithi_MembersMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getSamithi_Members } from "services/samithi_membersService";
import Layout from "template";
import { Constant } from "template/Constant";
import { Samithi_MembersForm } from "./form";
import { Samithi_MembersTable } from "./table";
import { APIService } from "services";
import {
  useParams
} from "react-router-dom";


export const Samithi_Members: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.samithi_members);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState('');
  // const { id } = useParams();

  // useEffect(() => {
  //     APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields",{type:"gramam",type_id:id}).then((response) => {
  //       if (response) {
  //         // dispatch(setSamithi_
  //         console.log("29response",response)
  //         // MembersList({ pageNo: page, pageSize: pageSize, list: response.records, totalCount: response.totalCount, searchKey: searchKey }));
  //       } else {
  // 		dispatch(setSamithi_MembersMessage("No Record Found"));
  //       }
  //     })
  //   },[])
  // let getData;

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(setSamithi_MembersMessage(''));
    setAction('edit');
  }

  function getData(page: any, pageSize: any, searchKey: any): void {
    throw new Error("Function not implemented.");
  }

  return (
    <Layout>
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          {/* <h1 className="h3 mb-0 text-gray-800">Samithi Members</h1> */}
        </div>
        <div className="d-flex flex-column min-vh-100">
          {rData.message ?
            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">
              <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setSamithi_MembersMessage(''))}>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert> : null}
          {/* getData={getData}  getData={getData}*/}
          {action ? <Samithi_MembersForm hideShowForm={setAction} action={action} row={row} getData={getData} /> :
            <Samithi_MembersTable handleRowEdit={handleRowEdit} hideShowForm={setAction} />}
        </div>
      </div>
    </Layout >
  );
};

